<template>
  <button
    class="text-color-topaz-light flex justify-center"
    @click="(showMore = nextPage), $emit('showMore', showMore)"
  >
    <span v-if="nextPage">
      {{ showMoreText }}
    </span>
    <span v-else>
      {{ showLessText }}
    </span>
    <picture
      class="ic-down-arrow-topaz"
      :class="
        !nextPage
          ? 'transform rotate-180 transition-all duration-300'
          : 'rotate-0'
      "
    >
      <source
        srcset="@/assets/images/ic-down-arrow-topaz.webp"
        type="image/webp"
      />
      <img
        src="@/assets/images/ic-down-arrow-topaz.svg"
        alt="Down arrow icon"
      />
    </picture>
  </button>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  showMoreText: {
    type: String,
    default: function() {
      return $t("general.buttons.showMore");
    }
  },
  showLessText: {
    type: String,
    default: function() {
      return $t("wegow.showLess");
    }
  },
  nextPage: {
    type: Boolean,
    default: false
  }
});
const emits = defineEmits(["showMore"]);

const showMore = ref(true);
</script>

<style></style>
